import { Link } from '@tanstack/react-router'

import { Button } from '@/_components/ui/button'

export const Success = () => {
  return (
    <Button asChild className="w-full">
      <Link to="/login">Acessar a plataforma</Link>
    </Button>
  )
}
